import React from 'react'
import { Form, FormControlProps, Text, Option } from 'rsuite'

type FormFieldRenderItem = Option<string | number> & { [key: string]: unknown }

type PickerPlacementChoices =
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'topStart'
  | 'topEnd'
  | 'leftStart'
  | 'leftEnd'
  | 'rightStart'
  | 'rightEnd'
  | 'bottomStart'
  | 'bottomEnd'
  | 'auto'
  | 'autoVerticalStart'
  | 'autoVerticalEnd'
  | 'autoHorizontalStart'
  | 'autoHorizontalEnd'

type Props = {
  name: string
  label?: string
  text?: string
  testId?: string
  data?: string[] | Option[] // what's type safety anyway?
  inline?: boolean
  suffix?: string
  block?: boolean
  searchable?: boolean
  loading?: boolean
  rows?: number
  placement?: PickerPlacementChoices
  maxLength?: number
  autoComplete?: string
  renderMenuItem?: (
    label: React.ReactNode,
    item: FormFieldRenderItem,
  ) => React.ReactNode
  renderValue?: (
    value: string | number,
    item: FormFieldRenderItem,
  ) => React.ReactNode
} & FormControlProps

const FormField: React.FC<Props> = (props: Props): React.ReactElement => {
  const { name, label, text, testId, ...rest } = props

  return (
    <Form.Group controlId={name}>
      {label && (
        <Form.Label>
          <Text weight="bold">{label}</Text>
        </Form.Label>
      )}
      <Form.Control name={name} data-testid={testId} {...rest} />
      {text && <Form.Text>{text}</Form.Text>}
    </Form.Group>
  )
}

export default FormField
